import React, { useEffect, useState } from 'react';
import { onTagInvitesRequested } from '../utils/invite';
import TagInviteDialog from './TagInviteDialog';

/** Mounted once in the app shell so the invite sheet survives the post composer closing. */
const TagInviteHost: React.FC = () => {
  const [postId, setPostId] = useState<string | null>(null);
  useEffect(() => onTagInvitesRequested(setPostId), []);
  return postId ? <TagInviteDialog postId={postId} onClose={() => setPostId(null)} /> : null;
};

export default TagInviteHost;
